var cry = require('./internals').cry

var levels = {
  ERROR   : 0,
  WARNING : 1,
  INFO    : 2,
  DEBUG   : 3,
}

var stringTolevel = {
  error   : levels.ERROR,
  info    : levels.INFO,
  warning : levels.WARNING,
  debug   : levels.DEBUG
}

levels.fromString = function (str) {
  if (typeof str === 'string') {
    str = str.toLowerCase(str)
    if (stringTolevel.hasOwnProperty(str)) return stringTolevel[str]
    cry(new Error('Niveau de log inconnu : ' + str))
  } else {
    cry(new Error('TypeError, faut une string'))
  }
}

module.exports = levels
